import React, { useState, useContext, useRef } from 'react';

import NavBar from './Navbar'
import Banner from './Banner'
import ProgressBar from './ProgressBar';
import InterpretationContent from './InterpretationContent'
import TranslationContent from './TranslationContent'
import Interpretation_Testing from './Interpretation_Testing'
import BilingualAssessmentContent_Page1 from './BilingualAssessmentContent_Page1'
import BilingualAssessmentContent_Page2 from './BilingualAssessmentContent_Page2'
import BilingualAssessmentContent_Page3 from './BilingualAssessmentContent_Page3'
import SignatureUpload from '../components/SignatureUpload'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import FadeIn from './FadeIn'
import ApprovalContent from './ApprovalContent';
import { CSSTransition } from 'react-transition-group';
import ContentContext from './ContentContext';
import NavBottom_Call_Mail_Youtube from './NavBottom_Call_Mail_Youtube'

/* Accordion */
import Directions_Accordion from './Directions_Accordion'

// Data context
import { TranslationProvider } from './TranslationContexts/TranslationDataContext'
import { LoadingProvider } from './PersistantContexts/LoadingStateContext';
import ApprovalContent_Interpretations from './ApprovalContent_Interpretations';
import ApprovalContent_Assessments from './ApprovalContent_Assessments';

import { useDispatch, useSelector } from 'react-redux'
import {backToInitialValuesUpdated} from '../redux/slices/translationSlice'
import {backToInitialValuesUpdated_int} from '../redux/slices/interpretationSlice'
import {backToInitialValuesUpdated_bil} from '../redux/slices/assessmentSlice'

// Checking if elements are on the viewport
import MySectionBlock from './MySectionBlock'

const Intake = ({ handleLogout }) => {
    //const [value, setValue] = useState(null)
    const [contentState, setContentState] = useState('main');// main / assessmentPage3
    const contentStateValue = { contentState, setContentState };
    const [tabState, setTabState] = useState(0)
    const HOME_URL = window.location.href;

    const dispatch = useDispatch();
    const translationState = useSelector((state) => state.translation);
    const interpretationState = useSelector((state) => state.interpretation);
    const assessmentState = useSelector((state) => state.assessment);

    const progressBarData = { bgcolor: "#00695c", completed: 0 }
    const [progressBarPercent, setProgressBarPercent] = useState(0)

    const handleProgressBarChangeInChild = (newAmount) => {
        //alert("NEW AMOUNT: " + newAmount)
        setProgressBarPercent(newAmount)
    }

    const handleTabChange = (event, newValue) => {
        if (newValue > -1) {
            dispatch(backToInitialValuesUpdated(translationState.backToInitialValues+1))
            dispatch(backToInitialValuesUpdated_int(interpretationState.backToInitialValues_int+1))
            dispatch(backToInitialValuesUpdated_bil(assessmentState.backToInitialValues_bil+1))
            setTabState(newValue)
            renderIntakeContent()
            setContentState('main')
        }

    }
    const handleContinueButton = function (newValue) {
        setContentState(newValue)
    }

    // All first pages
    const renderIntakeContent = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <InterpretationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        //else if (tabState == 1) return <Interpretation_Testing handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild}/>
        else return <BilingualAssessmentContent_Page1 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }
    
    // Second page for interp
    const renderTestingContent = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <Interpretation_Testing handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild}/>
        else return <BilingualAssessmentContent_Page1 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }

    // 
    const renderPage1 = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <InterpretationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild}/>
        else return <BilingualAssessmentContent_Page1 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }
    // Page 2 for Assessments
    const renderPage2 = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <InterpretationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild}/>
        else return <BilingualAssessmentContent_Page2 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }
    // Page 2 for Assessments
    const renderPage3 = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <InterpretationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild}/>
        else return <BilingualAssessmentContent_Page3 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }
    
    // Approval for Translation
    const renderTranslationApprovalContent = () => {
        if (tabState == 0) return <ApprovalContent  handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <InterpretationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else return <BilingualAssessmentContent_Page3 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }
    // Approval for Interpretations
    const renderInterpApprovalContent = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <ApprovalContent_Interpretations handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else return <BilingualAssessmentContent_Page3 handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }
    // Approval for Assessments
    const renderAssessmentApprovalContent = () => {
        if (tabState == 0) return <TranslationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else if (tabState == 1) return <InterpretationContent handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
        else return <ApprovalContent_Assessments handleContinueButton={handleContinueButton} handleProgressBarChange={handleProgressBarChangeInChild} />
    }

    const directionsTitle = "Directions (click to open)";
    const directionsContent = <span><ol><li>Please fill out the fields below. Fields marked <span style={{color:"red"}}>*</span> are required and must be filled in.</li><li>When all fields are complete the Next Page or Submit button (at the bottom) - will change from grey to blue.</li><li>This will take you to the next section or this will submit your Intake.</li><li>Use the progress bar in the top right to view your progress for this section.</li></ol><p>* Use the back button at the bottom of the form to go back to a previous page of that form (if applicable).</p></span>;

    const styles = {
        root: {
            flexGrow: 1,
        },
        appbar: {
            alignItems: 'center',
        }
    };
    const intakeStyle = {
        clear: 'both',
        width: '84%',
        marginLeft: 'auto',
        marginRight: 'auto',
        border: '1px solid rgb(204, 204, 204, 0.5)',
        minHeight: '690px',
    }

    const ContentStateContext = React.createContext('contentState');

    const [progressBarClass, setProgressBarClass] = useState('')

    const [showNavBottom, setShowNavBottom] = useState(true);

    return (
        <div className="hero">
        <LoadingProvider>
            <Banner homeUrl={HOME_URL} />
            <NavBar homeUrl={HOME_URL} changeTabState={handleTabChange} handleLogout={handleLogout} />
            <FadeIn delay={500} duration={450}>
            <TranslationProvider>
                <div style={intakeStyle}>
                    <AppBar position="static" className={styles.appbar.toString()}>
                        <Tabs value={tabState} onChange={handleTabChange}>
                            <Tab style={{color:"white", fontWeight:"bold"}} label={`Translation ${"\n"}(Written)`} />
                            <Tab style={{color:"white", fontWeight:"bold"}} label="Interpretation (Meeting)  " />
                            <Tab style={{color:"white", fontWeight:"bold"}} label="Bilingual Assessment" />
                        </Tabs>
                    </AppBar>

                   {/* <ProgressBar 
                        key={0} 
                        bgcolor={progressBarData.bgcolor} 
                        completed={progressBarPercent} 
                        fixedClass={progressBarClass}
                    />
                <MySectionBlock 
                    height="5px" 
                    onEnterViewport={() => {
                        console.log('enter viewportttt')
                        setProgressBarClass('')
                    }}
                    onLeaveViewport={() => {
                        console.log('leave viewportttt')
                        setProgressBarClass('progressBar-fixed')
                    }}
                />*/}
                    {/*<p className="intake-hr">&nbsp;</p>*/}
                    <div style={{ width: '100%', paddingTop: "1px" }}><Directions_Accordion title={directionsTitle} content={directionsContent} /></div>
                    <CSSTransition
                        in={contentState === 'main'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-primary"
                        onEnter={function(){setShowNavBottom(true);/*alert("ON ENTER main")*/}}
                        onExit={function(){setShowNavBottom(false);/*alert("ON EXIT main")*/}}
                    >
                        <ContentContext.Provider value={contentStateValue}>
                            <div className="intake-container">
                                {renderIntakeContent()}
                            </div>
                        </ContentContext.Provider>
                    </CSSTransition>



                    <CSSTransition
                        in={contentState === 'testing'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-primary"
                        onEnter={null}
                    >
                        <ContentContext.Provider value={contentStateValue}>
                            <div className="intake-container">
                                {renderTestingContent()}
                            </div>
                        </ContentContext.Provider>
                    </CSSTransition>



                    

                    <CSSTransition
                        in={contentState === 'assessmentPage2'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-primary"
                        onEnter={function(){setShowNavBottom(false);/*alert("ON ENTER assessmentPage2")*/}}
                        onExit={function(){setShowNavBottom(false);/*alert("ON EXIT assessmentPage2")*/}}
                    >
                        <ContentContext.Provider value={contentStateValue}>
                            <div className="intake-container">
                                {renderPage2()}
                            </div>
                        </ContentContext.Provider>
                    </CSSTransition>

                    <CSSTransition
                        in={contentState === 'assessmentPage3'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-primary"
                        onEnter={function(){setShowNavBottom(false);/*alert("ON ENTER assessmentPage3")*/}}
                        onExit={function(){setShowNavBottom(false);/*alert("ON EXIT assessmentPage3")*/}}
                    >
                        <ContentContext.Provider value={contentStateValue}>
                            <div className="intake-container">
                                {renderPage3()}
                            </div>
                        </ContentContext.Provider>
                    </CSSTransition>



                    <CSSTransition
                        in={contentState === 'approval-translation'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-secondary"
                        onEnter={null}
                    >
                        
                        <ContentContext.Provider value={contentStateValue}>
                            {renderTranslationApprovalContent()}
                        </ContentContext.Provider>
                        
                    </CSSTransition>

                    <CSSTransition
                        in={contentState === 'approval-interp'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-secondary"
                        onEnter={null}
                    >
                        
                        <ContentContext.Provider value={contentStateValue}>
                            {renderInterpApprovalContent()}
                        </ContentContext.Provider>
                        
                    </CSSTransition>

                    <CSSTransition
                        in={contentState === 'approval-assessment'}
                        unmountOnExit
                        timeout={500}
                        classNames="content-slide-secondary"
                        onEnter={null}
                    >
                        
                        <ContentContext.Provider value={contentStateValue}>
                            {renderAssessmentApprovalContent()}
                        </ContentContext.Provider>
                        
                    </CSSTransition>

                </div>
                </TranslationProvider>
                <br />
                <NavBottom_Call_Mail_Youtube show={setShowNavBottom}/>
            </FadeIn>
            </LoadingProvider>
        </div>
    )
}

export default Intake
